export function getFieldPaths(index: number) {
  const base = `fields.${index}`;

  return {
    organic: `${base}.organic`,
    lastOrganic: `${base}.last_organic`,
    isValidated: `${base}.is_validated`,
  } as const;
}
